import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import json_data from '../../../sample_data.json'

export default {
    $_veeValidate: {
      validator: 'new'
    },
    name: "ServiceFindYourService",
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack
    },
    data: () => ({
        find_your_service: "",
        search: null,
        find_your_service_previous: "",
        au_states: ['NSW','WA','QLD','SA','VIC','TAS','NT','ACT'],
        state: "",
        dictionary: {
            custom: {
                find_your_service: {
                    required: () => 'Find your service is required to proceed',
                    max: 'Cannot exceed more than 255 characters'
                },
                state: {
                    required: () => 'State is required to proceed'
                }
            }
        },
        search_temp_array: [],
        search_temp_array_bk_up: [],
        search_temp_ids: [],
        search_keyword: "",
        search_temp_paginated:[],
        //for local development
        datas: json_data,
        counter: 0

    }),
    watch: {
      search_temp_array: function (newVal, oldVal) {
        //val && val !== this.find_your_service && this.SearchKeyword(val)
        if(newVal.length != oldVal.length){
            this.counter = 0;
            this.search_temp_paginated = [];
            

            if((this.search_temp_paginated).length > 2 ){
                this.Output();
                this.AddScrollListener();
            }else{
                this.search_temp_paginated = this.search_temp_array;
                this.RemoveScrollListener();
            }
        }
      },
      search_temp_paginated: function (newVal, oldVal) {
          var str = this.find_your_service;
          var res = str.split(" ");
          if(this.search_temp_paginated.length > 4 && this.counter == 0 && res.length > 1){
              this.search_temp_paginated = [];
              this.Output();
          }
      }
    },
    methods: {
        handleScroll(){
            let el = document.getElementById('scrolly');
            let el_compute = el.scrollHeight - el.scrollTop;
            if(el_compute < 346){
                this.Output();
            }
        },
        Next() {
            this.$validator.validateAll().then((result) => {
                if(result) {
                    this.$parent.ServiceInsuranceProcess.find_your_service = this.find_your_service;
                    this.$parent.ServiceInsuranceProcess.state = this.state;
 
                    this.$parent.ServiceNextStep(1,"AuthorisedRepresentative");
                } else {
                    console.error("There seems to be an error in your entries");
                }
            });
        },
        ValidateSessionData() {
            if(this.$parent.ServiceInsuranceProcess.find_your_service != undefined) {
                this.find_your_service = this.$parent.ServiceInsuranceProcess.find_your_service;
                this.state = this.$parent.ServiceInsuranceProcess.state;
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        },
        Output(){
            let plus_;
            if((this.search_temp_array).length <= 2) {
                plus_ = (this.search_temp_array).length;
            }else{
                plus_ = 4;
            }

            let countr_ = this.counter + plus_;
            
            while(this.counter < countr_){
                let o = (this.search_temp_paginated).push(this.search_temp_array[this.counter]);
                this.counter++;
            }
        },
        GetServiceList(){
            var four = 0;
            this.counter = 0;

            //IF KEYWORD IS LESS THAN 3
            if((this.find_your_service).length <= 3){
                this.search_temp_array = [];
                this.search_temp_paginated = [];
                this.search_temp_ids = [];
                this.counter = 0;
                //this.RemoveScrollListener();
            }
            //IF KEYWORD LENGTH == 4
            else if((this.find_your_service).length == 4){
                this.SearchKeyword();           
            }
            //IF KEYWORD LENGTH GREATER THAN OR EQUAL TO 5
            else if((this.find_your_service).length >= 5){

                //IF KEYWORD - EXAMPLE - ``centre SE-0000159`` THEN THE USER DELETE THE 9 - THE KEYWORD WILL BE ``centre SE-000015``
                //WILL USE THE BACK UP RESULT FOR ``this.SearchKeyword`` for faster filtering instead of fetching again from GraphQL
                if((this.find_your_service).includes(this.search_keyword) == true){
                    this.search_temp_array = this.search_temp_array_bk_up;
                }
                //ELSE - IF KEYWORD HAS BEEN CHANGED FROM - EXAMPLE - ``centre SE-0000159`` TO ``education`` 
                //THIS MEANS WE NEED TO FETCH AGAIN FROM GRAPHQL
                else{
                    this.SearchKeyword();
                }

                //CHECK KEYWORD SPLIT LENGTH
                var str = this.find_your_service;
                var res = str.split(" ");

                if(res.length == 1){
                    let data_ = this.Filter(this.find_your_service);
                    this.find_your_service_previous = this.find_your_service;
                    this.search_temp_array = data_;
                }
                //IF KEYWORD IS MORE THAN 2 WORDS
                else{
                    //IF KEYWORD IS MORE THAN 2 WORDS AND KEYWORD IS COPY PASTE TO TEXTBOX
                    if((this.search_temp_array).length == 0){
                        this.SearchKeyword();
                    }
                    //ELSE - KEYWORD TYPE
                    else{
                        
                        let data_ = this.FilterMoreKeywords(res);
                        this.search_temp_array = data_;
                    }
                }   
            }
        },
        Filter(_searchKey) {
            return this.search_temp_array.filter(obj => Object.keys(obj).some(key => obj[key].toLowerCase().includes(_searchKey.toLowerCase())));

        },
        FilterMoreKeywords(_search_array_keyword){
            let i=0;
            let final_array = this.search_temp_array;


            for(i=1; i < _search_array_keyword.length; i++){

                let temp_array = final_array.filter(obj => Object.keys(obj).some(
                    key => obj[key].toLowerCase().includes(_search_array_keyword[i].toLowerCase())
                ));

                final_array = temp_array
            }

            return final_array;
        },
        SearchKeyword(){
            this.loading = true;
            this.search_temp_array = [];
            this.counter = 0;

            setTimeout(() => {
                this.search_keyword = this.find_your_service;

                //GRAPHQL 4 ENDPOINTS
                let url1 =   '/service/search_by_address.json?keyword=' + this.search_keyword;
                let url2 =   '/service/search_by_service_name.json?keyword=' + this.search_keyword;
                let url3 =   '/service/search_by_service_approval_number.json?keyword=' + this.search_keyword;
                let url4 =   '/service/search_by_post_code.json?keyword=' + this.search_keyword;

                let search_arr = [url1, url2, url3, url4];
                let i;

                for (i = 0; i < search_arr.length; i++) {
                    //----------LOCAL DEVELOPMENT

                    let y;
                    let data_ = this.datas.data.models.results;
                    for (y = 0; y < data_.length; y++){
                        if(this.search_temp_ids.indexOf(data_[y].id) == -1){
                            (this.search_temp_array).push(data_[y]);
                            (this.search_temp_ids).push(data_[y].id);
                        }
                    } 


                }
                
                this.search_temp_array_bk_up = this.search_temp_array;
                this.loading = false;
                this.Output();
            }, 500)
              
        } ,
        AddScrollListener(){
            document.getElementById('scrolly').addEventListener('scroll', this.handleScroll);
        },
        RemoveScrollListener(){
            document.getElementById('scrolly').removeEventListener('scroll', this.handleScroll);
        }
        
        
    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            let fld = this.fields;
            if(fld.find_your_service) {
                if(fld.find_your_service.valid && fld.state.valid) {
                    _isvalid = true;
                }
            }

            return _isvalid;
        }
    },
    mounted() {
        this.$validator.localize('en', this.dictionary) 
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData("ServiceInsuranceProcess");
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
        document.getElementById('scrolly').removeEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        document.getElementById('scrolly').removeEventListener('scroll', this.handleScroll);
    }
}